import { request } from "@/utils/remoteRequest";

export function getTree(data) {
  return request({
    url: "/basicDataType/tree",
    method: "post",
    data,
  });
}

export function getList(data) {
  return request({
    url: "/basicDataType/list",
    method: "post",
    data,
  });
}

export function reloadBasicData(data) {
  return request({
    url: "/basicData/reloadData",
    method: "post",
    data,
  });
}
//投递统计
export function getDataStatics(data) {
  return request({
    url: "/orgManage/getDataStatics",
    method: "post",
    data,
  });
}

export function searchBasicData(data) {
  return request({
    url: "/basicData/searchBasicData",
    method: "post",
    data,
  });
}

export function saveDataDictType(data) {
  return request({
    url: "/basicDataType/saveBasicDataType",
    method: "post",
    data,
  });
}

export function findBasicDataTypeById(data) {
  return request({
    url: "/basicDataType/findBasicDataTypeById",
    method: "post",
    data,
  });
}

export function saveData(data) {
  return request({
    url: "/basicData/saveBasicData",
    method: "post",
    data,
  });
}

export function findDataByTypeCode(data) {
  return request({
    url: "/basicData/findBasicDataByTypeCode",
    method: "post",
    data,
  });
}

export function findDataTreeByTypeCode(data) {
  return request({
    // url: "/basicData/findBasicDataTreeByTypeCode",
    url: "/basicData/findBasicDataTreeByTypeCode",
    method: "post",
    data,
  });
}

export function findDataListByTypeCode(data) {
  return request({
    // url: "/basicData/findBasicDataListByTypeCode",
    url: "/basicData/findBasicDataListByTypeCod",
    method: "post",
    data,
  });
}

export function deleteType(data) {
  return request({
    url: "/basicDataType/delete",
    method: "post",
    data,
  });
}

export function deleteData(data) {
  return request({
    url: "/basicData/deleteBasicData",
    method: "post",
    data,
  });
}
